// in src/comments.js
import * as React from 'react';
import { Box, Card, CardHeader, CardContent, Typography } from '@mui/material';
import {
    DateField,
    ShowButton,
    NumberField,
    TextField,
    BooleanField,
    useTranslate,
    useListContext,
    RaRecord,
    RecordContextProvider,
} from 'react-admin';

import { OrderCard } from '../../models/orderCard';

interface MobileGridProps {
    data?: RaRecord[];
}

const MobileGrid = (props: MobileGridProps) => {
    const { data, isLoading } = useListContext<OrderCard>();
    const translate = useTranslate();
    if (isLoading || data.length === 0) {
        return null;
    }
    return (
        <Box margin="0.5em">
            {data.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <Card sx={{ margin: '0.5rem 0' }}>
                        <CardHeader
                            title={
                                <>
                                    {translate('OrderId', 1)} #
                                    <TextField
                                        source="OrderId"
                                        variant="body2"
                                    />
                                </>
                            }
                            titleTypographyProps={{ variant: 'body2' }}
                            action={<ShowButton />}
                        />
                        <CardContent sx={{ pt: 0 }}>
                            <Typography variant="body2" gutterBottom>
                                {translate('date Created')}
                                :&nbsp;
                                <DateField source="dateCreated" showTime />
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                {translate(
                                    'amount'
                                )}
                                :&nbsp;
                                <NumberField
                                    source="amount"
                                    options={{
                                        style: 'currency',
                                        currency: 'USD',
                                    }}
                                />
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                {translate('status')}
                                :&nbsp;
                                <TextField source="eventCode" />
                            </Typography>
                            <Typography variant="body2">
                                {translate(
                                    'success'
                                )}
                                :&nbsp;
                                <BooleanField source="success" />
                            </Typography>
                        </CardContent>
                    </Card>
                </RecordContextProvider>
            ))}
        </Box>
    );
};

MobileGrid.defaultProps = {
    data: {},
    ids: [],
};

export default MobileGrid;